const footerBg = '#333';
const footerText = '#999';

export default {
  footerBg,
  footerText,
};
